import { render } from "./DashboardSettings.vue?vue&type=template&id=47113eef&scoped=true&lang=pug"
import script from "./DashboardSettings.vue?vue&type=script&lang=js"
export * from "./DashboardSettings.vue?vue&type=script&lang=js"

import "./DashboardSettings.vue?vue&type=style&index=0&id=47113eef&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47113eef"]])

export default __exports__